/**
 * 共有端末に関する定数
 */

/**
 * 共有端末の自動リセットタイムアウト時間（秒）
 */
export const SHARED_DEVICE_TIMEOUT_SECONDS = {
  COMPLETE: 30, // 予約完了画面: 30秒
  DEFAULT: 90, // その他の画面: 90秒
} as const;

/**
 * 自動リセット警告表示を開始する残り秒数
 */
export const SHARED_DEVICE_WARNING_THRESHOLD_SECONDS = 10;
